<ng-container *ngIf="startRender">
  <mat-form-field appearance="outline" class="example-full-width" [formGroup]="formGroup">
    <mat-label>{{placeholderText}}</mat-label>
    <input matInput placeholder="{{placeholderText}}" type="text" aria-label="Mobile" [formControl]="formControl" tabindex="{{tabindex}}">
    <mat-error>
      Enter a valid phone number
      <ng-container *ngIf="acceptedPhoneTypes.length || rejectedPhoneTypes.length"> for the selected type</ng-container>.
    </mat-error>
    <mat-spinner style="margin-top: 12px" [diameter]="20" *ngIf="formControl.status === 'PENDING'"></mat-spinner>
  </mat-form-field>
</ng-container>
